import { Link } from "@inertiajs/react"
import { Pencil } from "lucide-react"

import { Button } from "@/components/ui/button"
import InfoRow from "./InfoRow"

// The Personal information card — the read view of the customer's identity +
// contact fields, with an Edit button that opens the same modal as the header.
// Username + Email are read-only (D4). Pronouns is surfaced as a real editable
// identity row (it was absent from the static prototype) per D3.
export default function InfoCard({ identity, contact, onEdit }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-card">
      <div className="flex items-center justify-between gap-4 border-b border-border px-[22px] py-4">
        <h3 className="font-display text-[14.5px] font-bold">Personal information</h3>
        <Button variant="outline" size="sm" onClick={onEdit}>
          <Pencil className="size-3.5" strokeWidth={2} />
          Edit
        </Button>
      </div>

      <InfoRow label="Full name" value={identity?.name} />
      <InfoRow label="Username" value={identity?.username ? `@${identity.username}` : null} readOnly />
      <InfoRow label="Email" value={identity?.email} readOnly />
      <InfoRow label="Phone" value={contact?.phone} />
      <InfoRow label="Company" value={contact?.company} />
      <InfoRow label="Address" value={contact?.addressDisplay} />
      <InfoRow
        label="Time zone"
        value={<Link href="/settings" className="text-primary underline underline-offset-2">Manage in Settings</Link>}
      />
      <InfoRow label="Pronouns" value={identity?.pronoun} />
    </div>
  )
}
